import React from 'react'
import PropTypes from 'prop-types'

import { LoadingWave, MultiSelect } from '../../components'
import { sleep } from '../../utils'

export default class CanvasAssessments extends React.Component {
  static propTypes = {
    assessmentGroups: PropTypes.array.isRequired,
    canvasAssignments: PropTypes.array.isRequired,
    createCanvasAssignment: PropTypes.func.isRequired,
    deleteCanvasAssignment: PropTypes.func.isRequired,
    getAssessmentGroups: PropTypes.func.isRequired,
    getCanvasAssignments: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
  }

  state = {
    creating: [],
    deleting: [],
    loading: true,
  }

  async componentDidMount() {
    try {
      await Promise.all([
        this.props.getAssessmentGroups(),
        this.props.getCanvasAssignments(),
        sleep(1500), // to let the user read the changes
      ])
    } catch (error) {
      console.log(error)
    } finally {
      this.setState({ loading: false })
    }
  }

  _updating = () => this.state.creating.length || this.state.deleting.length

  _existsInCanvas = assessmentPk =>
    !!this.props.canvasAssignments.find(a => {
      const attributes = a.external_tool_tag_attributes
      return (
        attributes &&
        attributes.url.match(RegExp(`activity_id=${assessmentPk}`))
      )
    })
  _isChecked = assessmentPk => {
    const exists = this._existsInCanvas(assessmentPk)
    const creating = this.state.creating.includes(assessmentPk)
    const deleting = this.state.deleting.includes(assessmentPk)
    if (creating || deleting) {
      return !!creating
    } else {
      return exists
    }
  }

  _toggleAssignment = assessmentPk => {
    const creating = this.state.creating.includes(assessmentPk)
    const deleting = this.state.deleting.includes(assessmentPk)
    if (creating || deleting) {
      return
    }
    this._existsInCanvas(assessmentPk)
      ? this._deleteCanvasAssignment(assessmentPk)
      : this._createCanvasAssignment(assessmentPk)
  }

  _toggleGroup = group => {
    group.items.forEach(item => {
      this._toggleAssignment(item.pk)
    })
  }

  _createCanvasAssignment = async assessmentPk => {
    try {
      this.setState(state => ({
        creating: [...state.creating, assessmentPk],
      }))
      await this.props.createCanvasAssignment(assessmentPk)
    } catch (error) {
      console.error(error)
    } finally {
      this.setState(state => ({
        creating: state.creating.filter(pk => pk !== assessmentPk),
      }))
    }
  }

  _deleteCanvasAssignment = async assessmentPk => {
    try {
      this.setState(state => ({
        deleting: [...state.deleting, assessmentPk],
      }))
      await this.props.deleteCanvasAssignment(assessmentPk)
    } catch (error) {
      console.error(error)
    } finally {
      this.setState(state => ({
        deleting: state.deleting.filter(pk => pk !== assessmentPk),
      }))
    }
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="maxw-600px mx-auto text-center">
          <h4>Loading assessments...</h4>
          <LoadingWave />
        </div>
      )
    }
    const groups = this.props.assessmentGroups.filter(
      group => group.items.length > 0
    )
    if (!groups.length) {
      return (
        <div className="maxw-600px mx-auto text-center">
          <h4>No assessments available to import</h4>
          <p>
            Come back once you&apos;ve created some assessments and you can
            import them into your Canvas course to give students direct access
            and have grades reported back to Canvas automagically.
          </p>
          <button
            className="btn btn-lg btn-success"
            onClick={this.props.onFinish}
            type="button"
          >
            Next
          </button>
        </div>
      )
    }
    return (
      <div>
        <div className="maxw-600px mx-auto text-center mb-5">
          <h4>Choose Assessments to Import</h4>
          <p>
            Assessments you import into Canvas will be accessible to students
            directly in Canvas and grades will be reported back automagically.
          </p>
          <div className="text-left font-sm">
            {groups.map(group => (
              <div
                key={group.pk}
                className="shadow p-2 pb-4 mb-5 bg-white rounded border"
              >
                <MultiSelect
                  contentArray={group.items.map(assessment => ({
                    checked: this._isChecked(assessment.pk),
                    id: assessment.pk,
                    name: assessment.title,
                  }))}
                  label={group.title}
                  onSelected={event =>
                    this._toggleAssignment(event.target.value)
                  }
                  bulkSelect={false}
                  onBulkSelect={() => this._toggleGroup(group)}
                />
              </div>
            ))}
          </div>
          <button
            className="btn btn-lg btn-success"
            disabled={this._updating()}
            onClick={this.props.onFinish}
            type="button"
          >
            Next
          </button>
        </div>
      </div>
    )
  }
}
